import styled from 'styled-components';
import { Dialog } from '@mui/material';

import colors from '../../styles/colors';
import Input from '../MessageInput/components/Input';
import Button from '../Button';
import {
  modalButtonContainerStyle,
  modalButtonPrimaryStyle,
  modalButtonSecondaryStyle,
} from '../../constants/modals';

const StyledInput = styled(Input)`
  border-radius: 15px;
  border-color: ${colors.base.secondary};
  width: 100%;
  border-width: 1px;
`;

const ControlsContainer = styled.div`
  display: flex;
  justify-content: space-between;
  width: 100%;
  padding-top: 10px;
`;

const StyledButtonContainer = styled.div`
  ${modalButtonContainerStyle}
`;

const StyledSecondaryButton = styled(Button)`
  ${modalButtonSecondaryStyle}
`;

const StyledPrimaryButton = styled(Button)`
  ${modalButtonPrimaryStyle}
`;

const StyledDialog = styled(Dialog)`
  .MuiDialog-paper {
    overflow: visible;
  }
`;

export {
  StyledInput,
  ControlsContainer,
  StyledButtonContainer,
  StyledSecondaryButton,
  StyledPrimaryButton,
  StyledDialog,
};
